/* src/pages/Dashboard/Settings/Comp/Account.jsx
   --------------------------------------------------------------- */
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";

import Classes from "../Settings.module.css";
import {
  EmailIcon,
  AuthorizationIcon,
  EditIcon,
  CheckIcon,
  XIcon,
} from "../../../../../../utils/Icons";

import backend from "../../../../../../api";

export default function Account({ saveUser }) {
  const { user } = useSelector((s) => s.auth);

  const [form, setForm] = useState({
    email:    user.email,
    password: "********",
    newPass:  "",
  });
  const [editing, setEdit]  = useState(false);
  const [saving,  setSaving] = useState(false);

  const handleChange = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  /* ---- save ---- */
  const saveChanges = async () => {
    setSaving(true);
    try {
      /* email changed? */
      if (form.email !== user.email) {
        await saveUser({ email: form.email });
      }

      /* password changed? */
      if (form.newPass && form.newPass !== "********") {
        await backend.put(`/api/user/changepassword/${user._id}`, {
          password: form.newPass,
        });
      }
      setEdit(false);
      setForm((p) => ({ ...p, password: "********", newPass: "" }));
    } finally {
      setSaving(false);
    }
  };

  /* ---- cancel ---- */
  const cancelChanges = () => {
    setForm({
      email: user.email,
      password: "********",
      newPass: "",
    });
    setEdit(false);
  };

  return (
    <>
      <Backdrop open={saving} sx={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <div className={Classes.infoCon}>
        <h3>Account</h3>

        <section className={Classes.contentArea}>
          <div className={Classes.card}>
            {/* header */}
            <div className={Classes.cardHeader}>
              <h4>Login Information</h4>

              {!editing ? (
                <button className={Classes.editBtn} onClick={() => setEdit(true)}>
                  <EditIcon width="11" height="11" fill="#6E6E6E" /> Edit
                </button>
              ) : (
                <div style={{ display: "flex", gap: 8 }}>
                  <button className={Classes.editBtn} onClick={saveChanges}>
                    <CheckIcon width="11" height="11" fill="#6E6E6E" /> Save
                  </button>
                  <button className={Classes.editBtn} onClick={cancelChanges}>
                    <XIcon width="11" height="11" fill="#6E6E6E" /> Cancel
                  </button>
                </div>
              )}
            </div>

            {/* email */}
            <div className={Classes.cardRow}>
              <div className={Classes.rowBody}>
                <div className={Classes.flexAlign10}>
                  <EmailIcon width="14" height="14" fill="#6E6E6E" />
                  <span className={Classes.rowLabel}>Email Address</span>
                </div>
                {editing ? (
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    className={Classes.inputField}
                    required
                  />
                ) : (
                  <h5 className={Classes.textField}>{form.email}</h5>
                )}
              </div>
            </div>

            {/* password */}
            <div className={Classes.cardRow} style={{ margin: 0 }}>
              <div className={Classes.rowBody}>
                <div className={Classes.flexAlign10}>
                  <AuthorizationIcon width="14" height="14" fill="#6E6E6E" />
                  <span className={Classes.rowLabel}>Password</span>
                </div>

                {editing ? (
                  <input
                    type="password"
                    name="newPass"
                    placeholder="New Password"
                    value={form.newPass}
                    onChange={handleChange}
                    className={Classes.inputField}
                    minLength={6}
                    required
                  />
                ) : (
                  <h5 className={Classes.textField}>{form.password}</h5>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
